import React, { useEffect, useRef, useState } from 'react';
import { StrichSDK, BarcodeReader } from '@pixelverse/strichjs-sdk';

const BarcodeScanner = ({ onScan }) => {
  const barcodeReaderRef = useRef(null);
  const [srichFailure, setStrichFailure] = useState('');

  useEffect(() => {

    if (barcodeReaderRef.current == null) {
      initializeSDK();
    }
    return () => { };
  }, [onScan]);

  const initializeSDK = async () => {

    var jsString = document.getElementById('gfs-script-js-extra').innerText;
    var match = jsString.match(/strichOptions\s*=\s*({[^]*?})/);
    var jsonString = match ? match[1] : null;
    var jsonObject = JSON.parse(jsonString);
    const licenseKey = jsonObject.license_key;

    try {
      await StrichSDK.initialize(licenseKey);
      defineHostElement();
    } catch (error) {
      console.error('SDK initialization failed:', error);
      setStrichFailure(true);
    }
  };

  const defineHostElement = () => {
    const config = {
      selector: '#scanner',
      engine: {
        symbologies: [{ name: "ean13", qz: 10 }, 
          { name: "upca", qz: 10 }, 
          { name: "i25", minLen: 14, maxLen: 14 },
          { name: "code128", maxLen: 16 }],
        duplicateInterval: 750,
      },
      overlay: {
        showCameraSelector: true,
        showFlashlight: false,
        showDetections: true
      },
      locator: {
        regionOfInterest: {
          left: 0.05,
          right: 0.05,
          top: 0.2,
          bottom: 0.2,
        },
      },
      feedback: {
        audio: false,
        vibration: false,
      },
    };

    new BarcodeReader(config).initialize()
      .then(result => {
        barcodeReaderRef.current = result;
        barcodeReaderRef.current.detected = handleCodeDetection;
        return barcodeReaderRef.current.start();
      })
      .catch(error => {
        console.error('BarcodeReader initialization failed:', error);
      });
  };

  const handleCodeDetection = detections => {
    onScan(detections[0].data);

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: "strich_scan_attempt"
    });
  };

  if (!srichFailure) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div id="scanner" style={{ position: 'relative', height: '300px' }}>
          {/* BarcodeReader will be instantiated here */}
        </div>
        <div className="results">
          {/* Display scanned results */}
        </div>
        <div className="actions">
          {/* Action buttons, e.g., Save, Send, Cancel, etc. */}
        </div>
      </div>
    );
  } else {
    return (
      <p>Scanner Not Loading Properly</p>
    )
  };
};

export default BarcodeScanner;
